import { render, staticRenderFns } from "./ExpenseDocumentation.vue?vue&type=template&id=f2f596f2&scoped=true&"
import script from "./ExpenseDocumentation.vue?vue&type=script&lang=js&"
export * from "./ExpenseDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseDocumentation.vue?vue&type=style&index=0&id=f2f596f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f596f2",
  null
  
)

export default component.exports